/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidtrialrequesterror3Inputs */

const en_invalidtrialrequesterror3 = /** @type {(inputs: Invalidtrialrequesterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid trial request. Check the product type and duration.`)
};

const de_invalidtrialrequesterror3 = /** @type {(inputs: Invalidtrialrequesterror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige Testanfrage. Bitte Produkttyp und Dauer prüfen.`)
};

/**
* | output |
* | --- |
* | "Invalid trial request. Check the product type and duration." |
*
* @param {Invalidtrialrequesterror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidtrialrequesterror3 = /** @type {((inputs?: Invalidtrialrequesterror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidtrialrequesterror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidtrialrequesterror3(inputs)
	return de_invalidtrialrequesterror3(inputs)
});
export { invalidtrialrequesterror3 as "invalidTrialRequestError" }